export const PATHS = {
  TEAMS: "/teams",
  VENUES: "/venues",
  ADMINISTRATION: "/administration",
  LOGIN: "/login",
  ADS: "/ads",
  GOVERNING_BODIES: "/governing-bodies",
  QUALIFYING_SCORES: "/qualifying-scores",
  MESSAGE_TEMPLATES: "/message-templates",
  TOOLS: "/tools",
  RULES: "/rules",
};
